import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const WebflowDesign = () => {
  const pageData = {
    category: "WEBFLOW DESIGN",
    title: "Webflow Website Design & Development",
    description: "Create stunning, animation-rich websites on Webflow's powerful visual development platform. Perfect for marketing sites, portfolios, and businesses that want enterprise-level design with no-code content updates.",

    features: [
      {
        title: "Custom Webflow Site Design",
        description: "Pixel-perfect websites built in Webflow's visual editor with complete design freedom and professional aesthetics."
      },
      {
        title: "Animation & Interaction Design",
        description: "Engaging scroll-based animations, hover effects, and micro-interactions that bring your brand to life without code."
      },
      {
        title: "Webflow CMS Setup",
        description: "Flexible content management system for blogs, portfolios, case studies, and dynamic collection pages."
      },
      {
        title: "Responsive Design",
        description: "Mobile-first design approach ensuring perfect experiences across desktop, tablet, and mobile devices."
      },
      {
        title: "SEO & Performance",
        description: "Clean semantic HTML, fast hosting on Webflow's global CDN, and built-in SEO controls for optimal search rankings."
      },
      {
        title: "Client Training & Handoff",
        description: "Comprehensive training on Webflow's editor so you can make updates, publish content, and manage your site independently."
      }
    ],

    benefits: [
      {
        title: "Visual Design Freedom",
        description: "Design anything you can imagine without developer constraints or code limitations."
      },
      {
        title: "No-Code Updates",
        description: "Make design changes, update content, and launch new pages yourself without touching code or hiring developers."
      },
      {
        title: "Enterprise Performance",
        description: "Webflow's infrastructure delivers lightning-fast load times, 99.99% uptime, and automatic SSL certificates."
      },
      {
        title: "Built-in Hosting",
        description: "World-class hosting, CDN, backups, and security included with no need for separate hosting setup."
      }
    ],

    process: [
      {
        title: "Strategy & Wireframing",
        description: "Define site goals, create sitemap, develop wireframes, and plan content structure and user flows."
      },
      {
        title: "Visual Design",
        description: "Create high-fidelity designs in Figma or directly in Webflow, establishing typography, colors, and brand elements."
      },
      {
        title: "Webflow Development",
        description: "Build responsive pages in Webflow, implement animations, configure CMS collections, and integrate forms and tracking."
      },
      {
        title: "Launch & Training",
        description: "Deploy to custom domain, provide comprehensive Webflow editor training, and deliver maintenance documentation."
      }
    ],

    relatedServices: [
      {
        title: "Custom Websites",
        description: "React/Next.js development for complex web applications",
        link: "/services/web-development/custom-websites"
      },
      {
        title: "Shopify Development",
        description: "E-commerce solutions with custom Shopify themes",
        link: "/services/web-development/shopify"
      },
      {
        title: "Content Writing",
        description: "Professional copywriting to fill your Webflow site",
        link: "/services/seo/content-writing"
      }
    ],

    ctaText: "Ready to create a beautiful Webflow site you can update yourself? Let's bring your vision to life.",
    ctaLink: "/contact",
    parentLink: "/services/web-development",
    parentTitle: "Web Development"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Webflow Design Services" 
                description="Learn more about our Webflow Design services to grow your business online with Digi Network." 
                canonical="/web-development/webflow-design" 
            />

    </>
  );
};

export default WebflowDesign;
